import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import type { Root } from "react-dom/client";
import { App } from "./App";
import "./styles.css";

declare global {
  var __framnabidRoot: Root | undefined;
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Missing #root element");
}

const root = globalThis.__framnabidRoot ?? createRoot(rootElement);
globalThis.__framnabidRoot = root;

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
